import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { Textarea } from "../../../components/textfield";

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import {
  Select,
  Table,
  Input,
  Space,
  Row,
  Modal,
  InputNumber,
  Col,
  message,
  Button,
  Form,
  Typography,
  Checkbox,
} from "antd";

import { Icon } from "@iconify/react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { numberWithCommas } from "../../../helpers/functions";
import moment from "moment";
import GiftVoucher from "../../settings/product/giftVoucher";
import { Console } from "console";
const { Text } = Typography;
interface ParamTypes {
  other?: string;
  id: string;
}

const Cart = () => {
  const { TextArea } = Input;
  const history = useHistory();
  const { user, isFetchedUser } = useSelector((state: any) => state);
  const { id } = useParams<ParamTypes>();
  const { confirm } = Modal;
  let [formComplication] = Form.useForm();
  let [formFull] = Form.useForm();

  const [isDisbled, setisDisbled] = useState<boolean>(false);
  const [isDisbledTransferCourse, setisDisbledTransferCourse] =
    useState<boolean>(false);
  const [transferGiftvoucher, settransferGiftvoucher] = useState<any>({
    price: 0,
    giftVoucherGC: null,
    transferCourse: null,
  });
  const [description, setDescription] = useState<string>("");
  const [dataCart, setDataCart] = useState<any>([]);
  const [typePurchase, setTypePurchase] = useState<string>("");
  const [optFree, setOptFree] = useState<any>([]);
  const [typeFree, setTypeFree] = useState<any>("เลือก/Select");
  const [sum, setSum] = useState<any>([{ totalDiscount: 0, balanceafter: 0 }]);
  // const [sumDiscount, setSumDisCount] = useState<number>(0);
  const [isShowDiscount, setisShowDiscount] = useState<boolean>(false);
  const [idPurchase, setIdPurchase] = useState<any>([]);
  const [ColIndex, setColIndex] = useState<number>(0);
  const [title, settitle] = useState<any>("");
  const [column, setColumn] = useState<any>([]);
  const [datas, setdatas] = useState<any>([]);
  const [dataGc, setDataGc] = useState<any>([]);
  const [discountMarget, setdiscountMarget] = useState<number>(0);
  const [valueGc, setvalueGc] = useState<string>("");
  const [checkDoc, setCheckDoc] = useState<string>("");
  const [checkSales, setCheckSales] = useState<string>("");

  const [selectedFreeValue, setSelectedFreeValue] = useState<string>("");

  const [approveDoc, setApproveDoc] = useState<any>([]);
  const [approveName, setApproveName] = useState<any>([]);

  const [checkValFree, setCheckValFree] = useState<string>("เลือก/Select");
  const dateFormat = "DD-MM-YYYY";

  const getApproveName = async () => {
    const data = await axios.get(`/users?page=1&branch=all&search=`);
    const xDoctor = [];
    const xUser = [];
    console.log("user", data?.data?.data);

    const user = data?.data?.data.filter(
      (datares: any) => datares?.permission?.name !== "CS"
    );

    console.log("user", user);

    const Doctor = data?.data?.data.filter(
      (datares: any) => datares?.permission?.name === "CS"
    );

    let xoptfrees = {
      code: "ไม่ระบุ/Not Specified",
      id: "",
      displayName: "ไม่ระบุ/Not Specified",
    };
    Doctor.push(xoptfrees);
    user.push(xoptfrees);

    // console.log("Doctor =>>>>", Doctor);

    for (let i = 0; i < Doctor?.length; i++) {
      xDoctor.push(
        <Select.Option value={Doctor[i]?._id} key={Doctor[i]?._id}>
          {Doctor[i]?.displayName}
        </Select.Option>
      );
    }
    setApproveDoc(xDoctor);

    for (let i = 0; i < user?.length; i++) {
      xUser.push(
        <Select.Option value={user[i]?._id} key={user[i]?._id}>
          {user[i]?.displayName}
        </Select.Option>
      );
    }
    setApproveName(xUser);
  };

  const getOptionFree = async () => {
    await axios.get(`/product-frees`).then((res) => {
      // console.log("res free", res?.data?.data);
      let optFrees = res?.data?.data;
      console.log("optFrees", optFrees);

      let optFreesNew = [...optFrees];
      let xoptfrees = {
        code: "ไม่เลือก/Not Select",
        id: "",
        name: "ไม่เลือก/Not Select",
      };
      optFreesNew.push(xoptfrees);
      // console.log("optFreesNew", optFreesNew);

      const optFree = [];
      for (let i = 0; i < optFreesNew?.length; i++) {
        optFree.push(
          <Select.Option value={optFreesNew[i]?.code} key={optFreesNew[i]?._id}>
            {optFreesNew[i]?.name}
          </Select.Option>
        );
      }
      setOptFree(optFree);
    });
  };

  const onChangeFree = (value: any, index: any) => {
    console.log("value free v2", value);

    setSelectedFreeValue(value.children);

    let xDatas = [...dataCart];

    console.log("index changeFree", index);

    console.log("typefree", value.children);

    // console.log("xDatas", xDatas);
    let Credit = parseFloat(xDatas[index].specialPrice);
    // console.log("Credit", Credit);

    if (
      value.children === "บัตรกำนัล/Gift Voucher" ||
      value.children === "แลกเปลี่ยนสินค้า(ภาษี)/Barther (Vat)"
    ) {
      const xtotal =
        parseInt(xDatas[index].price) * parseInt(xDatas[index].quantity) -
        Credit;
      if (xtotal > 0) {
        xDatas[index].totalPrice = xtotal;
      } else {
        xDatas[index].totalPrice = 0;
      }
    } else if (
      value.children === "ไม่เลือก/Not Select" ||
      value.children === "เลือก/Select"
    ) {
      funcSetSelectedFreeValue(value.children, index);

      const xtotal =
        parseInt(xDatas[index].price) * parseInt(xDatas[index].quantity);
      xDatas[index].totalPrice = xtotal;
      xDatas[index].free.barther = null;
      xDatas[index].free.giftVoucher = null;
      xDatas[index].specialPrice = 0;
      xDatas[index].specialDiscount = 0;
      xDatas[index].free.codefree = "";
    } else if (
      value.children === "ของประกอบ(แถม)/Complementary" ||
      value.children === "ภาวะแทรกซ้อน/Complication" ||
      value.children === "วิชา/การฝึกอบรม/Subject/Training" ||
      value.children === "สวัสดิการ/Welfare" ||
      value.children === "การตลาด/Marketing"
    ) {
      funcSetSelectedFreeValue(value.children, index);

      // const xtotal =

      // console.log("xtotal", xtotal);

      xDatas[index].totalPrice = 0;
      xDatas[index].free.barther = null;
      xDatas[index].free.giftVoucher = null;
      xDatas[index].specialDiscount = 0;
      xDatas[index].specialPrice =
        parseInt(xDatas[index].price) * parseInt(xDatas[index].quantity);
      xDatas[index].free.codefree = "";
    }

    // xDatas[index].totalPrice;

    //     if
    // { setCheckValFree}

    // setSelectedFreeIndex(index);

    xDatas[index].free.productFree = value.key;
    setCheckValFree(value.children);

    setDataCart(xDatas);
    setTypeFree(value.children);
    setColIndex(index);
    selectFree(value.children);
  };

  const selectFree = (type: any) => {
    console.log("type", type);

    if (type === "บัตรกำนัล/Gift Voucher") {
      axios.get(`/gift-vouchers?giftVoucher=gv%2Cge`).then((res) => {
        const datasVoucher = res?.data?.data;
        console.log("datasVoucher", datasVoucher);

        let xNewDataVoucher = datasVoucher.filter(
          (data: any) => data.giftVoucherType === "specific_treatment"
          // && data.isUsed === false /// รอพี่เจทำต่อ
        );

        console.log("xNewDataVoucher", xNewDataVoucher);

        setColumn(columsVoucher);
        setdatas(xNewDataVoucher);
        settitle("ค้นหาบัตรกำนัล/Search Gift Voucher");
        setisDisbled(true);
      });
    } else if (type === "แลกเปลี่ยนสินค้า(ภาษี)/Barther (Vat)") {
      axios.get(`/barthers`).then((res) => {
        const dataBarther = res?.data?.data;
        console.log("dataBarther", dataBarther);
        setColumn(columsBarther);
        setdatas(dataBarther);
        settitle("ค้นหาการแลกเปลี่ยนสินค้า(ภาษี)/Search Barther (Vat)");
        setisDisbled(true);
      });
    } else if (type === "ภาวะแทรกซ้อน/Complication") {
      getApproveName();
      // formDiscount.setFieldsValue({ discountMarket: "" });
      setisShowDiscount(true);
    }
  };

  const OnChangeGC = (value: any) => {
    console.log("change ge", value); //เอาแค่ gc

    if (value === "Select a full discount") {
      axios.get(`/gift-vouchers?giftVoucher=gv`).then((res) => {
        let transfer = {
          _id: "0000001",
          code: "EK-TFC63010001",
          detail: "โอนคอร์ส/Filler (Juvederm Vollift)",
          credit: 3200,
          dateStart: "15/07/2022",
          dateEnd: "25/07/2022",
          giftVoucher: "ek",
        };

        let datasVoucher = res?.data?.data;

        // console.log("datasVoucher Gc", datasVoucher);

        let NewdatasVoucher = datasVoucher.filter(
          (data: any) => data.giftVoucherType === "limit"
          // && data.isUsed === false /// รอพี่เจทำต่อ
        );
        console.log("newdatasVoucher", NewdatasVoucher);

        NewdatasVoucher.push(transfer);

        // console.log("newdatasVoucher push", NewdatasVoucher);

        setDataGc(NewdatasVoucher);
        setisDisbledTransferCourse(true);
      });
    } else {
      // getSumDiscount();
      let xnewsum = sum.map((data: any) => ({
        ...data,
        totalDiscount: data?.totalDiscount - transferGiftvoucher?.price,
        balanceafter: data?.balanceafter + transferGiftvoucher?.price,
      }));
      setSum(xnewsum);
      console.log("credit transfer change else", transferGiftvoucher);

      setvalueGc("");
      settransferGiftvoucher({
        price: 0,
        giftVoucherGC: null,
        transferCourse: null,
      });

      console.log("sum", sum);
    }
  };

  const onCheckGc = (value: any) => {
    // console.log("datacart checkGc", dataCart);
    // console.log("dataGc", dataGc);
    // console.log("transferGift", transferGiftvoucher);

    let xnewdatagc = dataGc.find((data: any) => data.treatment === dataCart.id);

    // console.log("xnewdatagc", xnewdatagc);

    // let newTransferGift = dataCart.map((data: any) => ({
    //   ...data,
    //   value.id,
    // }));

    // if (value?.giftVoucherType == "specific_treatment") {
    //   if (dataCart._id === value?.treatment) {
    //     let xNewData = [...dataCart];
    //     xNewData[ColIndex].totalPrice -= parseFloat(value?.credit);
    //     setDataCart(xNewData);
    //   }
    // } else {
    // }

    // settransferGiftvoucher(value?.credit);
    // console.log("giftVoucher", value?.giftVoucher);

    // console.log("credit", value?.credit);

    if (value.giftVoucher !== "gv") {
      console.log("value check gv=>>>>>>>", value);

      settransferGiftvoucher({
        price: value?.credit,
        giftVoucherGC: value,
        transferCourse: null,
      });
      // console.log("sum discount =>>>>>", sumDiscount + value?.credit);
    } else {
      settransferGiftvoucher({
        price: value?.credit,
        giftVoucherGC: null,
        transferCourse: value,
      });
    }
    // setSumDisCount(sumDiscount + value?.credit);
    // setSum(sum - value?.credit);
    setvalueGc(value.detail);
  };

  const setTypePrice = (xdata: any) => {
    console.log("customerTypeCode", xdata?.customerTypeCode);

    const localPrice = ["CNT", "CNM", "CNS"];
    const agencyPrice = ["CNA", "CNC", "CNE", "CNF"];

    let typecode = "";

    if (localPrice.includes(xdata?.customerTypeCode)) {
      typecode = "Local";
    } else if (agencyPrice.includes(xdata?.customerTypeCode)) {
      typecode = "Agency";
    }

    getDataTableCart(xdata?.items, typecode);
  };

  useEffect(() => {
    console.log("transferGift", transferGiftvoucher);
  }, [transferGiftvoucher]);

  const columns = [
    {
      title: "รหัส/Code",
      dataIndex: "code",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any) => {
        return (
          <Row justify="start">
            <Space>
              <Icon
                onClick={() => {
                  showDeleteConfirm(record?._id, record?.name);
                }}
                icon="ant-design:minus-circle-filled"
                color="#E76464"
                width="24"
                height="24"
              />

              {text}
            </Space>
          </Row>
        );
      },
    },
    {
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as const,
      width: "20%",
    },
    {
      title: "ราคา/หน่วย/Price/Unit",
      dataIndex: "price",
      align: "center" as const,
      width: "8%",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      title: "จำนวน/Quantity",
      dataIndex: "quantity",
      align: "center" as const,
      width: "8%",
      render: (text: any, record: any, index: number) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            onClick={() => reduceQuantity(text, index, record)}
            style={{ cursor: "pointer" }}
          >
            <Icon icon="mdi:menu-left" width="30" height="30" color="#AEAEAE" />
          </div>
          {/* <div>{text}</div> */}
          <InputNumber
            size="middle"
            style={{ width: "30%" }}
            min={1}
            // max={10}
            bordered={false}
            value={text}
            controls={false}
            onChange={(e: any) => {
              onchangequantity(e, index, record);
            }}
            // readOnly
          />
          <div
            onClick={() => addQuantity(text, index, record)}
            style={{ cursor: "pointer" }}
          >
            <Icon
              icon="mdi:menu-right"
              width="30"
              height="30"
              color="#AEAEAE"
            />
          </div>
        </div>
      ),
    },
    {
      title: "รวม/Total",
      dataIndex: "total",
      align: "center" as const,
      width: "8%",
      render: (text: any, record: any, index: number) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      title: () => {
        return (
          <div>
            <text>{"จำนวน/คอร์ส"}</text>
            <br />
            <text>{"/Number/Course"}</text>
          </div>
        );
      },
      dataIndex: "number",
      align: "center" as const,
      width: "8%",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text)}</>;
      },
    },
    {
      title: "คอมมิชชั่น/Commission",
      align: "center" as const,
      children: [
        {
          title: "พนักงานขาย/Sales",
          dataIndex: "isCommissionSales",
          width: "4%",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
        {
          title: "แพทย์/Doctor",
          dataIndex: "isCommissionDoctor",
          width: "4%",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
      ],
    },
    {
      title: "ฟรี/Free",
      dataIndex: "free",
      align: "center" as const,
      width: "15%",
      render: (text: any, record: any, index: number) => {
        return (
          <>
            <Select
              style={{ width: "100%" }}
              defaultValue={"เลือก/Select"}
              onSelect={(e: any, record: any) => {
                onChangeFree(record, index);
              }}
              value={record.selectedFree ? record.selectedFree : "เลือก/Select"}
              suffixIcon={
                <Icon
                  icon="ant-design:caret-down-filled"
                  style={{ color: "#AEAEAE" }}
                />
              }
            >
              {optFree}
            </Select>
          </>
        );
      },
    },
    {
      title: "รหัสฟรี/Code Free",
      dataIndex: "codefree",
      align: "center" as const,
      width: "10%",
      render(text: any, record: any) {
        return record?.free?.codefree;
        // console.log("record code Free=>>>>>>>>>>>>>>>>", record);
      },
    },
    {
      title: "ส่วนลดพิเศษ/Special Discount",
      dataIndex: "specialPrice",
      width: "8%",
      align: "center" as const,
      render(text: any, record: any) {
        return {
          props: {
            style: { background: "#D3D8DD" },
          },
          children: <div>{numberWithCommas(text, 2)}</div>,
        };
      },
    },
    {
      title: "ราคาพิเศษ/Special Price",
      dataIndex: "specialDiscount",
      align: "center" as const,
      width: "10%",

      render: (text: any, record: any, index: number) => {
        return {
          props: {
            style: {
              background:
                record?.free?.productFree !== undefined &&
                record?.free?.productFree !== null
                  ? "#D3D8DD"
                  : "",
            },
          },
          children: (
            <div>
              {record?.free?.productFree !== undefined &&
              record?.free?.productFree !== null ? (
                numberWithCommas(0, 2)
              ) : (
                <InputNumber
                  type="number"
                  style={{
                    height: "auto",
                    border: "none",
                    borderRadius: "0px",
                    borderBottom: "2px solid #d9d9d9",
                  }}
                  value={record?.specialDiscount}
                  // bordered={false}
                  min={0}
                  onChange={(e: any) => {
                    OnChangeSpecialDiscount(e, index);
                  }}
                  controls={false}
                ></InputNumber>
              )}
            </div>
          ),
        };
      },
    },
    {
      title: "ราคารวม/Total Price",
      dataIndex: "totalPrice",
      align: "center" as const,
      width: "15%",
      render: (text: any, record: any, index: number) => {
        return (
          <>
            {numberWithCommas(text, 2)}
            {/* {console.log("text total", record)} */}
          </>
        );
      },
    },

    {
      title: "ความเห็น/Remark",
      dataIndex: "remark",
      align: "center" as const,

      render: (text: any, record: any, index: number) => {
        return (
          <Row style={{ width: "150px" }}>
            <Input
              type="text"
              defaultValue={text !== "" ? text : ""}
              maxLength={20}
              onChange={(e: any) => OnChangeRemark(e, index)}
            />
          </Row>
        );
      },
    },
  ];
  const columnsPromotion = [
    {
      title: "รหัส/Code",
      dataIndex: "code",
      align: "center" as const,
      width: "200px",
      render: (text: any, record: any) => {
        return (
          <Row justify="start">
            <Space>
              <Icon
                onClick={() => {
                  showDeleteConfirm(record?._id, record?.name);
                }}
                icon="ant-design:minus-circle-filled"
                color="#E76464"
                width="24"
                height="24"
              />

              {`${text}`}
            </Space>
          </Row>
        );
      },
    },
    {
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as const,
      width: "450px",
    },
    {
      title: "ราคา/หน่วย/Price/Unit",
      dataIndex: "price",
      align: "center" as const,
      width: "200px",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      title: "จำนวน/Quantity",
      dataIndex: "quantity",
      align: "center" as const,
      width: "180px",
      render: (text: any, record: any, index: number) => (
        <>
          {record?.refGiftVoucher === null ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                onClick={() => reduceQuantity(text, index, record)}
                style={{ cursor: "pointer" }}
              >
                <Icon
                  icon="mdi:menu-left"
                  width="30"
                  height="30"
                  color="#AEAEAE"
                />
              </div>
              <InputNumber
                size="middle"
                style={{ width: "30%" }}
                min={1}
                // max={10}
                bordered={false}
                value={text}
                controls={false}
                onChange={(e: any) => {
                  onchangequantity(e, index, record);
                }}
                // readOnly
              />
              <div
                onClick={() => addQuantity(text, index, record)}
                style={{ cursor: "pointer" }}
              >
                <Icon
                  icon="mdi:menu-right"
                  width="30"
                  height="30"
                  color="#AEAEAE"
                />
              </div>
            </div>
          ) : (
            <Text
              disabled
              style={{ color: "black" }}
              // readOnly
            >
              {1}
            </Text>
          )}
        </>
      ),
    },
    // {
    //   title: "รวม/Total",
    //   dataIndex: "total",
    //   align: "center" as const,
    //   width: "10%",
    //   render: (text: any, record: any, index: number) => {
    //     return <>{numberWithCommas(text, 2)}</>;
    //   },
    // },
    {
      title: "คอมมิชชั่น/Commission",
      align: "center" as const,
      children: [
        {
          title: "พนักงานขาย/Sales",
          dataIndex: "isCommissionSales",
          width: "150px",
          align: "center" as const,
          render: (text: any, record: any, index: number) => (
            <>
              {/* {console.log("record", record)} */}

              {record?.refGiftVoucher === null ? (
                <Space>
                  <Checkbox
                    defaultChecked={record?.isCommissionSales}
                    onChange={(e: any) => {
                      let x = [...dataCart];
                      x[index].isCommissionSales = e.target.checked;
                      setDataCart(x);
                    }}
                    // disabled={
                    //   record?.promotionType === "normal_limit" ? false : true
                    // }
                  ></Checkbox>
                  <Text>ได้</Text>
                </Space>
              ) : (
                <Space>
                  <Checkbox
                    defaultChecked={
                      record?.promotionType === "normal_limit" ? true : false
                    }
                    onChange={(e: any) => {
                      let x = [...dataCart];
                      x[index].isCommissionDoctor = e.target.checked;
                      setDataCart(x);
                    }}
                    disabled={
                      record?.promotionType === "normal_limit" ? false : true
                    }
                  ></Checkbox>
                  <Text>ได้</Text>
                </Space>
              )}
            </>
          ),
        },
        {
          title: "แพทย์/Doctor",
          dataIndex: "isCommissionDoctor",
          width: "150px",
          align: "center" as const,
          render: (text: any, record: any, index: number) => (
            <div>
              {record?.refGiftVoucher === null ? (
                <Space>
                  <Checkbox
                    defaultChecked={record?.isCommissionDoctor}
                    onChange={(e: any) => {
                      let x = [...dataCart];
                      x[index].isCommissionDoctor = e.target.checked;
                      setDataCart(x);
                    }}
                    // disabled={
                    //   record?.promotionType === "normal_limit" ? false : true
                    // }
                  ></Checkbox>
                  <Text>ได้</Text>
                </Space>
              ) : (
                <Space>
                  {/* {console.log("checkDoc", checkDoc)}
                  {console.log("record", record)} */}

                  <Checkbox
                    defaultChecked={
                      checkDoc === null || checkDoc === "" ? false : true
                    }
                    onChange={(e: any) => {
                      let x = [...dataCart];
                      x[index].isCommissionDoctor = e.target.checked;
                      setDataCart(x);
                    }}
                  ></Checkbox>
                  <Text>ได้</Text>
                </Space>
              )}
            </div>
          ),
        },
      ],
    },

    // {
    //   title: "ราคารวม/Total Price",
    //   dataIndex: "totalPrice",
    //   align: "center" as const,
    //   width: "10%",
    //   render: (text: any, record: any, index: number) => {
    //     return <>{text > 0 ? numberWithCommas(text, 2) : 0}</>;
    //   },
    // },

    {
      title: "ความเห็น/Remark",
      dataIndex: "remark",
      align: "center" as const,
      width: "15%",
      render: (text: any, record: any, index: number) => {
        return (
          <Row style={{ width: "100%" }}>
            <Input
              type="text"
              defaultValue={text !== "" ? text : ""}
              maxLength={20}
              onChange={(e: any) => OnChangeRemark(e, index)}
            />
          </Row>
        );
      },
    },
  ];
  const columstransfer = [
    {
      title: "รหัส/Code",
      dataIndex: "code",
      align: "center" as const,
    },
    {
      title: "รายละเอียด/Detail",
      dataIndex: "detail",
      align: "center" as const,
    },
    {
      title: "ราคาเครดิต/PriceCreddit",
      dataIndex: "credit",
      align: "center" as const,
      render: (text: any, record: any) => {
        return numberWithCommas(text, 2);
      },
    },
    {
      title: "วันที่ออก/Date Start",
      dataIndex: "startDate",
      align: "center" as const,
      width: "13%",
      render: (text: any, record: any) => {
        // console.log("text datestart xxx", text);

        return moment(text).format(dateFormat);
      },
    },
    {
      title: "วันหมดอายุ/Date End",
      dataIndex: "endDate",
      align: "center" as const,
      width: "13%",
      render: (text: any, record: any) => {
        return moment(text).format(dateFormat);
      },
    },
  ];
  const columsVoucher = [
    {
      title: "รหัสบัตรกำนัล/Gift Code",
      dataIndex: "code",
      align: "center" as const,
    },
    {
      title: "รายละเอียดบัตรกำนัล/Gift Detail",
      dataIndex: "detail",
      align: "center" as const,
    },
    {
      title: "ราคาเครดิต/PriceCreddit",
      dataIndex: "credit",
      align: "center" as const,
      render: (text: any, record: any) => {
        return numberWithCommas(text, 2);
      },
    },
    {
      title: "วันที่ออก/Date Start",
      dataIndex: "startDate",
      align: "center" as const,
      width: "13%",
      render: (text: any, record: any) => {
        return moment(text).format(dateFormat);
      },
    },
    {
      title: "วันหมดอายุ/Date End",
      dataIndex: "endDate",
      align: "center" as const,
      width: "13%",
      render: (text: any, record: any) => {
        return moment(text).format(dateFormat);
      },
    },
  ];
  const columsBarther = [
    {
      title: "รหัสการแลกเปลี่ยน/BartherCode",
      dataIndex: "code",
      align: "center" as const,
    },
    {
      title: "รายละเอียดการแลกเปลี่ยน/BartherDetail",
      dataIndex: "detail",
      align: "center" as const,
    },
    {
      title: "ราคาเครดิต/PriceCreddit",
      dataIndex: "credit",
      align: "center" as const,
      width: "15%",
      render: (text: any, record: any) => {
        return numberWithCommas(text, 2);
      },
    },
    {
      title: "วันที่ออก/Date Start",
      dataIndex: "startDate",
      align: "center" as const,
      width: "13%",
      render: (text: any, record: any) => {
        return moment(text).format(dateFormat);
      },
    },
    {
      title: "วันหมดอายุ/Date End",
      dataIndex: "endDate",
      align: "center" as const,
      width: "13%",
      render: (text: any, record: any) => {
        return moment(text).format(dateFormat);
      },
    },
  ];

  const getAPIs = () => {
    getOptionFree();
    axios.get(`/so/get-cart?memberId=${id}`).then((res) => {
      console.log("ress apisss=>", res?.data);
      let datas = res?.data;
      setCheckDoc(datas?.doctor);
      // setCheckSales(datas?.consults?.)
      setTypePrice(datas);
      setIdPurchase(res?.data?._id);
      setTypePurchase(datas?.purchaseType);

      // console.log("datas refvoucher", datas?.items[0]?.refGiftVoucher);

      settransferGiftvoucher({
        price:
          datas?.fullDiscount?.price !== undefined
            ? datas?.fullDiscount?.price
            : 0,
        giftVoucherGC: datas?.fullDiscount?.giftVoucherGC,
        transferCourse: datas?.fullDiscount?.transferCourse,
      });
      setDescription(datas?.note);
    });
  };

  const getDataTableCart = (data: any, typeCode?: string) => {
    console.log("data cart getdataTable => ", data);

    const Datas = data.map((datas: any) => ({
      ...datas,
      rawnumber: parseFloat(datas?.number),
      number: parseFloat(datas?.number) * parseInt(datas?.quantity),
      specialPrice: datas?.specialPrice === undefined ? 0 : datas?.specialPrice,
      specialDiscount:
        datas?.specialDiscount === undefined ? 0 : datas?.specialDiscount,
      price:
        typeCode === "Local"
          ? parseInt(datas?.price)
          : parseInt(datas?.priceAgency),
      total:
        typeCode === "Local"
          ? parseInt(datas?.price) * parseInt(datas?.quantity)
          : parseInt(datas?.priceAgency) * parseInt(datas?.quantity),
      totalPrice:
        datas?.total !== datas?.totalPrice
          ? datas?.totalPrice
          : typeCode === "Local"
          ? parseInt(datas?.price) * parseInt(datas?.quantity)
          : parseInt(datas?.priceAgency) * parseInt(datas?.quantity),
      free:
        //  datas?.free,
        {
          // productFree:
          //   datas?.free?.productFree !== null
          //     ? datas?.free?.productFree?._id
          //     : null,
          productFree:
            datas?.free?.productFree !== null
              ? datas?.free?.productFree?._id
              : null,
          giftVoucher:
            datas?.free?.giftVoucher !== null
              ? datas?.free?.giftVoucher?._id
              : null,
          barther:
            datas?.free?.barther !== null ? datas?.free?.barther?._id : null,
          discount: datas?.free?.discount !== 0 ? datas?.free?.discount : 0,
          codefree: datas?.free?.codefree,
        },
      selectedFree: datas?.free?.productFree?.name
        ? datas?.free?.productFree?.name
        : "เลือก/Select",

      totalDiscount: 0,
      remark: datas?.remark !== null ? datas?.remark : null,
      consults: datas?.consults,
    }));
    console.log("data=>>", Datas);
    // setOptFree(datas?.free?.productFree?._id);

    setDataCart(Datas);
  };

  const deleteData = async (itemid: any) => {
    try {
      console.log("itemid", itemid);

      const xdelete = dataCart.filter((data: any) => data._id !== itemid);
      setDataCart(xdelete);
      await axios
        .delete(`/so/remove-item?soId=${idPurchase}&itemId=${itemid}`)
        .then((res) => {
          // console.log("res", res?.data);
          getAPIs();
        });
    } catch (error) {
      console.log("err", error);
      return;
    }
  };

  const OnChangeSpecialDiscount = (value: any, index: number) => {
    console.log("value=", value);
    console.log("index=", index);

    if (value !== null) {
      const SpecialDiscount = parseInt(value);
      console.log("SpecialDiscount", SpecialDiscount);
      let xDatas = [...dataCart];

      const xtotal =
        parseInt(xDatas[index].price) * parseInt(xDatas[index].quantity);
      xDatas[index].totalPrice = xtotal + SpecialDiscount;
      // console.log("totalPrice", ;
      xDatas[index].specialDiscount = SpecialDiscount;
      xDatas[index].specialPrice = 0;

      setDataCart(xDatas);
    } else {
      let xDatas = [...dataCart];
      const xtotal =
        parseInt(xDatas[index].price) * parseInt(xDatas[index].quantity);
      xDatas[index].totalPrice = xtotal;
      xDatas[index].specialDiscount = 0;

      setDataCart(xDatas);
    }
  };

  const OnChangeRemark = (val: any, index: number) => {
    if (val.target.value !== "") {
      const NewRemark = [...dataCart];
      NewRemark[index].remark = val.target.value;
      setDataCart(NewRemark);
    }
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          {/* {console.log("name", name)} */}
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(id);
      },
      width: "fit-content",
    });
  }

  function showConfirm() {
    confirm({
      title: "",
      content: (
        <>
          {/* {console.log("name", name)} */}
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการสั่งซื้อหรือไม่ ?`}</div>
          <div>{`Are you sure to Checkout ?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        OnSummary();
      },
      width: "fit-content",
    });
  }

  useEffect(() => {
    getAPIs();
  }, []);

  useEffect(() => {
    console.log("datacart useeffect =>", dataCart);
    getSumDiscount();
  }, [dataCart]);

  const getSumDiscount = () => {
    let newdata = [...dataCart];
    // const xnewsum = newdata.map((data: any) => ({
    //   ...data,
    //   totalDiscount: newdata.reduce((a, b) => (a = a + b.specialPrice), 0),
    // }));

    console.log("giftvoucher", transferGiftvoucher?.price);

    console.log("newdata sumdis", newdata);

    let xnewsum = sum.map((data: any) => ({
      ...data,
      balanceafter:
        newdata.reduce((a, b) => (a = a + b.totalPrice), 0) -
        transferGiftvoucher?.price,
      totalDiscount:
        newdata.reduce((a, b) => (a = a + b.specialPrice), 0) +
        transferGiftvoucher?.price,
    }));

    console.log("xnewsum", xnewsum);

    setSum(xnewsum);
  };

  useEffect(() => {
    console.log("ColIndex", ColIndex);
  }, [ColIndex]);

  const addQuantity = (values: any, index: any, record: any) => {
    let newValue = [...dataCart];
    newValue[index].quantity = newValue[index].quantity + 1;
    console.log("typeFree", typeFree);
    console.log("index", index);
    console.log("record", record);

    console.log("values", values);

    if (
      record.selectedFree === "แลกเปลี่ยนสินค้า(ภาษี)/Barther (Vat)" ||
      record.selectedFree === "บัตรกำนัล/Gift Voucher" ||
      record.selectedFree === "ไม่เลือก/Not Select" ||
      record.selectedFree === "เลือก/Select"
    ) {
      console.log("if =>>>>>>>");
      console.log("check newVal add", newValue[index]);

      const specialPrice =
        newValue[index].specialPrice === undefined
          ? 0
          : parseFloat(newValue[index].specialPrice);
      console.log("total Price", newValue[index].totalPrice);

      const specialDiscount =
        newValue[index].specialDiscount === undefined
          ? 0
          : parseFloat(newValue[index].specialDiscount);

      const XnewTotal =
        newValue[index].price * newValue[index].quantity -
        specialPrice +
        specialDiscount;

      console.log("XnewTotal =>>>>>>>", XnewTotal);

      if (XnewTotal > 0) {
        newValue[index].totalPrice = XnewTotal;
      } else {
        newValue[index].totalPrice = 0;
      }
      newValue[index].total = newValue[index].price * newValue[index].quantity;
      newValue[index].number =
        newValue[index].rawnumber * newValue[index].quantity;
    } else if (
      record.selectedFree === "ของประกอบ(แถม)/Complementary" ||
      record.selectedFree === "ภาวะแทรกซ้อน/Complication" ||
      record.selectedFree === "วิชา/การฝึกอบรม/Subject/Training" ||
      record.selectedFree === "สวัสดิการ/Welfare" ||
      record.selectedFree === "การตลาด/Marketing"
    ) {
      console.log("else =>>>>>>>");

      const price = newValue[index].price * newValue[index].quantity;
      newValue[index].totalPrice = 0;
      newValue[index].specialPrice = price;
      newValue[index].total = price;
      newValue[index].number =
        newValue[index].rawnumber * newValue[index].quantity;
    }
    setDataCart(newValue);
  };

  const reduceQuantity = (values: any, index: any, record: any) => {
    console.log("values reduce", values);

    let newValue = [...dataCart];
    console.log("newValue reduce", newValue);

    if (newValue[index].quantity > 1) {
      newValue[index].quantity = newValue[index].quantity - 1;

      if (
        record.selectedFree === "แลกเปลี่ยนสินค้า(ภาษี)/Barther (Vat)" ||
        record.selectedFree === "บัตรกำนัล/Gift Voucher" ||
        record.selectedFree === "ไม่เลือก/Not Select" ||
        record.selectedFree === "เลือก/Select"
      ) {
        const specialPrice =
          newValue[index].specialPrice === undefined
            ? 0
            : parseFloat(newValue[index].specialPrice);

        const XnewTotal =
          newValue[index].price * newValue[index].quantity - specialPrice;

        console.log("XnewTotal =>>>>>>>", XnewTotal);

        if (XnewTotal > 0) {
          newValue[index].totalPrice = XnewTotal;
        } else {
          newValue[index].totalPrice = 0;
        }

        newValue[index].total =
          newValue[index].price * newValue[index].quantity;
        newValue[index].number =
          newValue[index].rawnumber * newValue[index].quantity;
      } else if (
        record.selectedFree === "ของประกอบ(แถม)/Complementary" ||
        record.selectedFree === "ภาวะแทรกซ้อน/Complication" ||
        record.selectedFree === "วิชา/การฝึกอบรม/Subject/Training" ||
        record.selectedFree === "สวัสดิการ/Welfare" ||
        record.selectedFree === "การตลาด/Marketing"
      ) {
        // const totalPrice = parseFloat(newValue[index].totalPrice);
        // newValue[index].totalPrice = totalPrice - newValue[index].price;
        // newValue[index].total = totalPrice - newValue[index].price;

        const price = newValue[index].price * newValue[index].quantity;
        newValue[index].totalPrice = 0;
        newValue[index].specialPrice = price;
        newValue[index].total = price;
        newValue[index].number =
          newValue[index].rawnumber * newValue[index].quantity;
      }
      setDataCart(newValue);
    }
  };

  const onchangequantity = (e: any, index: number, record: any) => {
    console.log("changequantity");

    if (e !== null) {
      console.log("e", e);
      let newquantity = [...dataCart];
      newquantity[index].quantity = e;
      setDataCart(newquantity);
      if (
        record.selectedFree === "แลกเปลี่ยนสินค้า(ภาษี)/Barther (Vat)" ||
        record.selectedFree === "บัตรกำนัล/Gift Voucher" ||
        record.selectedFree === "ไม่เลือก/Not Select" ||
        record.selectedFree === "เลือก/Select"
      ) {
        const specialPrice = parseFloat(newquantity[index].specialPrice);
        let XnewTotal =
          newquantity[index].price * newquantity[index].quantity - specialPrice;

        if (XnewTotal > 0) {
          newquantity[index].totalPrice = XnewTotal;
        } else {
          newquantity[index].totalPrice = 0;
        }

        newquantity[index].total =
          newquantity[index].price * newquantity[index].quantity;
        newquantity[index].number =
          newquantity[index].rawnumber * newquantity[index].quantity;
      } else if (
        record.selectedFree === "ของประกอบ(แถม)/Complementary" ||
        record.selectedFree === "ภาวะแทรกซ้อน/Complication" ||
        record.selectedFree === "วิชา/การฝึกอบรม/Subject/Training" ||
        record.selectedFree === "สวัสดิการ/Welfare" ||
        record.selectedFree === "การตลาด/Marketing"
      ) {
        const specialPrice = parseFloat(newquantity[index].specialPrice);
        let XnewTotal =
          newquantity[index].price * newquantity[index].quantity - specialPrice;

        if (XnewTotal > 0) {
          newquantity[index].totalPrice = 0;
        } else {
          newquantity[index].totalPrice = 0;
        }

        const price = newquantity[index].price * newquantity[index].quantity;

        newquantity[index].total = price;
        newquantity[index].number =
          newquantity[index].rawnumber * newquantity[index].quantity;

        // newValue[index].totalPrice = 0;
        newquantity[index].specialPrice = price;
        // newValue[index].total = price;
        // newValue[index].number =
        //   newValue[index].rawnumber * newValue[index].quantity;
      }
      // totalPrice - newquantity[ColIndex].price;
      setDataCart(newquantity);

      // setSum({ totalDiscount: 0, balanceafter: 0 });
    }
  };

  useEffect(() => {
    console.log("balanceDis", sum[0].balanceafter);
  }, [sum]);

  const addDatasSpecialPrice = (value: any) => {
    // console.log("typeFree", typeFree);
    console.log("value addDataSpecial", value);

    addSpecialPrice(value);
  };

  const addSpecialPrice = (data: any) => {
    console.log("ColIndex", ColIndex);
    let xDatas = [...dataCart];
    if (
      typeFree === "แลกเปลี่ยนสินค้า(ภาษี)/Barther (Vat)" ||
      typeFree === "บัตรกำนัล/Gift Voucher"
    ) {
      // const xtotal =
      //   parseInt(xDatas[index].price) * parseInt(xDatas[index].quantity);
      if (typeFree === "บัตรกำนัล/Gift Voucher") {
        xDatas[ColIndex].free.giftVoucher = data?._id;
        xDatas[ColIndex].free.barther = null;
        xDatas[ColIndex].specialDiscount = 0;
      } else {
        xDatas[ColIndex].free.barther = data?._id;
        xDatas[ColIndex].free.giftVoucher = null;
        xDatas[ColIndex].specialDiscount = 0;
      }
      xDatas[ColIndex].specialPrice = data?.credit;

      xDatas[ColIndex].free.codefree = data?.code;
      console.log("data?.credit", data?.credit);
    }
    setDataCart(xDatas);
    calTotalPrice(data);
  };

  const calTotalPrice = (data: any) => {
    let xDatas = [...dataCart];
    const Credit = parseFloat(data?.credit);

    const newTotal =
      xDatas[ColIndex].price * xDatas[ColIndex].quantity - Credit;
    console.log("newTotal", newTotal);

    if (newTotal > 0) {
      xDatas[ColIndex].totalPrice = newTotal;
    } else {
      xDatas[ColIndex].totalPrice = 0;
    }

    // console.log("totalPrice", ;
    setDataCart(xDatas);
  };

  const onchangeDiscountMargeting = (val: any) => {
    console.log("val", val);
    if (val !== null) {
      setdiscountMarget(val);
    }
  };

  const calfulldiscount = (val: any) => {
    if (val?.giftVoucher === "ek") {
      message.error("ยังไม่สามารถใช้โอนคอร์สได้ / Not Available");
      return;
    }
    onCheckGc(val);
    setisDisbledTransferCourse(false);
    console.log("record transfer", val);
    console.log("datacart fulldis ", dataCart);

    // console.log("transferGiftvoucher cal full", transferGiftvoucher);

    console.log("transfer =>>>", transferGiftvoucher);

    let credit = val?.credit; //5000

    const NewDataCart = dataCart.map((data: any, index: any) => ({
      ...data,
      index: index,
    }));

    const gvArr = [];

    for (const xdata of val.treatments) {
      // console.log("data", xdata);

      const gv = NewDataCart.find((code: any) => code._id === xdata);

      if (gv) {
        gvArr.push(gv);
      }
    }
    console.log("gvArr", gvArr);
    if (gvArr.length === 0) {
      message.info("ไม่มีการใช้วงเงิน");
    }
    const newCresit = credit;
    let checkTotal = gvArr.reduce((a, b) => (a = a + b.totalPrice), 0);

    if (checkTotal === 0) {
      console.log("check=>>>>>");
      message.info("ไม่สามารถใช้วงเงินได้");
      settransferGiftvoucher({ ...transferGiftvoucher, price: 0 });
    } else {
      for (let index = 0; index < gvArr.length; index++) {
        const element = gvArr[index];

        if (element.totalPrice >= credit) {
          credit = newCresit;
          console.log("credit 1", credit);
          break;
        } else if (element.totalPrice < credit) {
          credit = credit - element.totalPrice;
          console.log("credit 2", credit);
        }

        console.log("credit", credit);

        // console.log("element", element.totalPrice);
      }

      // settransferGiftvoucher({ price: credit });
      console.log("newCresit", newCresit);

      if (credit < newCresit) {
        settransferGiftvoucher({
          ...transferGiftvoucher,
          price: newCresit - credit,
          giftVoucherGC: val,
          transferCourse: null,
        });

        console.log("transfer", transferGiftvoucher);

        let xnewsum = [...dataCart];
        xnewsum = sum.map((data: any) => ({
          totalDiscount:
            xnewsum.reduce((a, b) => (a = a + b.specialPrice), 0) +
            newCresit -
            credit,
          balanceafter: data?.balanceafter - newCresit + credit,
        }));

        console.log("xnewsum 1", xnewsum);

        setSum(xnewsum);
      } else {
        settransferGiftvoucher({
          ...transferGiftvoucher,
          price: credit,
          giftVoucherGC: val,
          transferCourse: null,
        });
        let xnewsum = [...dataCart];
        let xsumCredit =
          xnewsum.reduce((a, b) => (a = a + b.specialPrice), 0) + credit;
        console.log("xsumCredit", xsumCredit);

        xnewsum = sum.map((data: any) => ({
          totalDiscount: xsumCredit,
          balanceafter:
            xnewsum.reduce((a, b) => (a = a + b.total), 0) - xsumCredit,
        }));

        console.log("xnewsum 2 ", xnewsum);

        setSum(xnewsum);
      }
    }

    console.log("checkTotal", checkTotal);

    // credit

    // for (let i = 0; i > credit; i++) {

    //  for (let i = 0; i > gvArr.length; i++) {

    //   xnewcredit -
    // }

    //   NewGv = gvArr[i]?.totalPrice - credit;
    //   console.log("credit", credit);

    //   console.log("NewGv", NewGv);
    // }
  };

  const OnSubmitComplication = (value: any) => {
    console.log("value submit", value);
    setisShowDiscount(false);
  };

  const OncheckSelectRow = (record: any) => {
    // TODO:: click barther
    console.log("record check Row v1.1", record);
    console.log("typeFree", typeFree);

    console.log("dataCart", dataCart);

    funcSetSelectedFreeValue(selectedFreeValue);

    if (typeFree === "แลกเปลี่ยนสินค้า(ภาษี)/Barther (Vat)") {
      const xData = dataCart.filter(
        (data: any) => record?._id === data?.free?.barther
      );
      console.log("xData", xData);

      if (xData.length > 0) {
        message.error(
          "เลือก Barther (Vat) ไปแล้ว / Already Select Barther (Vat)"
        );
      } else {
        addDatasSpecialPrice(record);
        setisDisbled(false);
      }
    } else if (typeFree === "บัตรกำนัล/Gift Voucher") {
      if (dataCart[ColIndex]?._id !== record?.treatment) {
        message.error("ไม่สามารถใช้ Giftvoucher ได้ / Giftvoucher not match");
        return;
      }

      const xData = dataCart.filter(
        (data: any) => record?._id === data?.free?.giftVoucher
      );
      console.log("xData", xData);

      if (xData.length > 0) {
        message.error("เลือก Gift Voucher ไปแล้ว / Already Select Voucher");
      } else {
        addDatasSpecialPrice(record);
        setisDisbled(false);
      }
      console.log("data", dataCart);
    }

    // const new'

    // message.error('xData')
  };

  const OncheckSelectRowBarther = (record: any) => {
    console.log("record check Row", record);

    // const new'
    console.log("data", dataCart);

    const xData = dataCart.filter(
      (data: any) => record?._id === data?.free?.barther
    );
    console.log("xData", xData);

    if (xData.length > 0) {
      message.error(
        "เลือก Barther (Vat) ไปแล้ว / Already Select Barther (Vat)"
      );
    } else {
      // addDatasSpecialPrice(record);
      // setisDisbled(false);
    }

    // message.error('xData')
  };

  const funcSetSelectedFreeValue = (
    value: any = "เลือก/Select",
    index?: number
  ) => {
    console.log("test.......v1", value);

    console.log("index", index);

    if (!index) {
      index = ColIndex;
    }

    console.log("index check", index);

    // uncheck
    let xDatas = [...dataCart];
    console.log("xDatas[index] =>", xDatas[index]);

    xDatas[index].selectedFree = value;
    console.log("xDatas after [index] =>", xDatas[index]);

    setDataCart(xDatas);
  };

  const checkFreeSelected = () => {
    // console.log("ColIndex", ColIndex);
    const newDatas = [...dataCart];
    newDatas[ColIndex].free.productFree = null;
    newDatas[ColIndex].free.codefree = "";
    newDatas[ColIndex].free.giftVoucher = "";
    newDatas[ColIndex].free.barther = "";
    newDatas[ColIndex].free.barther = "";
    newDatas[ColIndex].specialPrice = 0;
    newDatas[ColIndex].totalPrice = newDatas[ColIndex].total;
    setDataCart(newDatas);
    setCheckValFree("เลือก/Select");

    console.log("selectedFreeValue =>", selectedFreeValue);

    funcSetSelectedFreeValue();
  };
  const OnSummary = () => {
    // console.log("datacart", dataCart);

    if (dataCart.length > 0) {
      console.log("transfer", transferGiftvoucher);
      let xdata = [...dataCart];

      console.log("type", typePurchase);

      console.log("barther", xdata[0]?.free?.barther);
      console.log("giftvoucher", xdata[0]?.free?.barther);

      let newdata = {};
      if (typePurchase === "normal") {
        newdata = xdata.map((data: any, index: number) => ({
          _id: data._id,
          price: data.price,
          quantity: data.quantity,
          number: data?.number,
          isCommissionSales: data.isCommissionSales,
          isCommissionDoctor: data.isCommissionDoctor,
          specialPrice: data.specialPrice,
          specialDiscount: data.specialDiscount,
          totalPrice: data.totalPrice,
          free: {
            productFree: data.free.productFree,
            giftVoucher: data.free.giftVoucher,
            barther: data?.free?.barther,
            discount: data?.free?.discount,
            codefree: data?.free?.codefree,
          },
          remark: data.remark,
        }));
      } else if (typePurchase === "promotion") {
        newdata = xdata.map((data: any, index: number) => ({
          _id: data._id,
          price: data.price,
          quantity: data.quantity,
          number: data?.number,
          isCommissionSales:
            data?.promotionType === "normal_limit"
              ? true
              : data?.isCommissionSales,
          isCommissionDoctor:
            checkDoc !== null ? true : data.isCommissionDoctor,
          specialPrice: data.specialPrice,
          specialDiscount: data.specialDiscount,
          totalPrice: data.totalPrice,
          free: {
            productFree: data.free.productFree,
            giftVoucher: data.free.giftVoucher,
            barther: data?.free?.barther,
            discount: data?.free?.discount,
            codefree: data?.free?.codefree,
          },
          remark: data.remark,
        }));
      }
      console.log("newdata=>>>>>>", newdata);

      console.log("summary", dataCart);
      console.log("note", description);
      // console.log("totalDiscountAmount", sumDiscount);
      console.log("balanceAfterAllDiscount", sum);

      // history.push(`/opd/so/conclusion/${id}`);

      // console.log("test", {
      //   items: newdata,
      //   note: description,
      //   fullDiscount: transferGiftvoucher,
      //   totalDiscountAmount: sumDiscount,
      //   balanceAfterAllDiscount: sum,
      // });
      // return;
      try {
        axios
          .patch(`/so/update-cart?memberId=${id}`, {
            items: newdata,
            note: description,
            fullDiscount: transferGiftvoucher,
            totalDiscountAmount: sum[0].totalDiscount,
            balanceAfterAllDiscount: sum[0].balanceafter,
          })
          .then((res) => {
            console.log("res", res);
            history.push(`/opd/so/conclusion/${id}`);
          });
      } catch (error) {
        message.error("มีข้อผิดพลาด");
        return;
      }
    } else {
      message.error("คุณยังไม่ได้เลือกรายการที่ซื้อ / Plese Select Somting");
      return;
    }
  };

  return (
    <div>
      <HeaderBar title="รายการที่ซื้อ/Purchase Item" btnBack />
      <div style={{ margin: "20px 40px" }}>
        {/* modal voucher and barter vat */}
        <Modal
          visible={isDisbled}
          onCancel={() => {
            setisDisbled(false);
            // console.log("ColIndex", ColIndex);
            checkFreeSelected();
          }}
          closable={false}
          footer={null}
          className="modal-doctor"
        >
          <h5>{title}</h5>
          <div className="input-search">
            <Input.Search
              bordered={false}
              onSearch={(e) => {
                // setDataSearch({ ...dataSearch, search: e})
              }}
            />
          </div>

          <div style={{ marginTop: "20px" }} className="table-data">
            {console.log("type", typePurchase)}

            <Table
              columns={column}
              dataSource={datas}
              scroll={{ x: 100, y: 300 }}
              pagination={false}
              bordered
              rowKey="_id"
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    OncheckSelectRow(record);
                  }, // click row
                  // onDoubleClick: (event) => {}, // double click row
                  // onContextMenu: (event) => {}, // right button click row
                  // onMouseEnter: (event) => {}, // mouse enter row
                  // onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </Modal>
        {/* modal discount marke  */}
        <Modal
          visible={isShowDiscount}
          onCancel={() => {
            setisShowDiscount(false);
            // console.log("ColIndex", ColIndex);
            checkFreeSelected();
          }}
          footer={false}
          width={"400px"}
          centered
        >
          <Form form={formComplication} onFinish={OnSubmitComplication}>
            <Row justify="center" className="custom-card">
              <Col span={24}>
                <h5>Complication</h5>
              </Col>

              <Col span={24} style={{ padding: "20px" }}>
                <Row>
                  <Col span={24}>
                    <div className="heading">
                      <p>Approved By Dr.</p>
                    </div>
                    <Form.Item
                      name="ComplicationName"
                      rules={[
                        {
                          required: true,
                          message: "กรุณาเลือก Approved By Dr.!",
                        },
                      ]}
                    >
                      <Select
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                      >
                        {approveDoc}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24} style={{ marginTop: "20px" }}>
                    <div className="heading">
                      <p>Approved By Sales</p>
                    </div>
                    <Form.Item
                      name="ComplicationSurName"
                      rules={[
                        {
                          required: true,
                          message: "กรุณาเลือก Approved By!",
                        },
                      ]}
                    >
                      <Select
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                      >
                        {approveName}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              {/* {console.log("discountMarget", discountMarget)} */}
              {/* <Col>
                {discountMarget > dataCart[ColIndex]?.maximumDiscount && (
                  <>
                    <p style={{ color: "red" }}>
                      ส่วนลดเกินกำหนด ต้องรอการอนุมัติ/
                    </p>
                    <p style={{ color: "red" }}>
                      Overdue Discount Awaiting Approval
                    </p>
                  </>
                )}
              </Col> */}
            </Row>

            <Row justify="center" style={{ marginTop: "20px" }}>
              <Space>
                <Button
                  style={{
                    background: "#FF6760",
                    color: "white",
                    height: "50px",
                    borderRadius: "0.25rem",
                  }}
                  onClick={() => {
                    setisShowDiscount(false);
                    checkFreeSelected();
                  }}
                >
                  ยกเลิก/Cancel
                </Button>
                <Button
                  htmlType="submit"
                  style={{
                    background: "#4D7E7F",
                    color: "white",
                    height: "50px",
                    borderRadius: "0.25rem",
                  }}
                >
                  ตกลง/Submit
                </Button>
              </Space>
            </Row>
          </Form>
        </Modal>

        {/* modal Gc โอนคอร์ส */}
        <Modal
          visible={isDisbledTransferCourse}
          // onCancel={() => setisDisbledTransferCourse(false)}
          footer={null}
          className="modal-doctor"
          closable={false}
        >
          <h5>
            ค้นหาบัตรกำนัลหรือการโอนคอร์ส/Search Gift Voucher or Transfer Course
            Item
          </h5>
          <div className="input-search">
            <Input.Search
              bordered={false}
              onSearch={(e) => {
                // setDataSearch({ ...dataSearch, search: e})
              }}
            />
          </div>

          <div style={{ marginTop: "20px" }} className="table-data">
            <Table
              columns={columstransfer}
              dataSource={dataGc}
              scroll={{ x: 100, y: 300 }}
              pagination={false}
              bordered
              rowKey="_id"
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    console.log("record", record);

                    calfulldiscount(record);
                  }, // click row
                  // onDoubleClick: (event) => {}, // double click row
                  // onContextMenu: (event) => {}, // right button click row
                  // onMouseEnter: (event) => {}, // mouse enter row
                  // onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </Modal>

        <div style={{ marginTop: "20px" }}>
          <div style={{ marginTop: "20px" }} className="table-data">
            {/* {console.log("datacart", dataCart)} */}
            <Table
              columns={
                typePurchase === "promotion" ? columnsPromotion : columns
              }
              dataSource={dataCart}
              bordered
              scroll={typePurchase === "promotion" ? { x: 1200 } : { x: 2500 }}
              rowKey="_id"
              pagination={false}
            />
          </div>
        </div>
        <div
          className="row space-between mt-40"
          style={{ padding: "0px 10px" }}
        >
          <div className="col-6">
            {/* <TextArea
              style={{ width: "80%", justifyContent: "center" }}
              autoSize={{ minRows: 4, maxRows: 5 }}
             
            /> */}
            <Textarea
              placeholder="หมายเหตุ/Note"
              value={description}
              onChange={(e: any) => {
                setDescription(e.target.value);
              }}
            ></Textarea>
          </div>
          <div className="col-6">
            {typePurchase === "normal" && (
              <h5 style={{ padding: "0px 20px", fontSize: "14px" }}>
                เลือก ส่วนลดทั้งรายการ/Select a full discount.
              </h5>
            )}
            {typePurchase === "normal" && (
              <div style={{ padding: "0px 20px" }}>
                <table width="100%" style={{ fontSize: "14px" }}>
                  <tr
                    style={{
                      backgroundColor: "#fff",
                      height: "50px",
                    }}
                  >
                    <td
                      style={{
                        borderRight: "1px solid #aaa",
                        padding: "0px 10px",
                        width: "50%",
                      }}
                      // onClick={() => {
                      //   setIsGiftVoucher(true);
                      // }}
                    >
                      <Select
                        style={{ width: "100%" }}
                        options={[
                          { value: "ไม่เลือก/Not Select", name: "notchoose" },
                          {
                            value: "Select a full discount",
                            name: "choose",
                          },
                        ]}
                        onChange={(e: any) => {
                          OnChangeGC(e);
                        }}
                        value={
                          transferGiftvoucher?.price === 0
                            ? "ไม่เลือก/Not Select"
                            : transferGiftvoucher?.giftVoucherGC?.code
                        }
                      ></Select>
                    </td>
                    <td
                      // align=""
                      style={{
                        borderLeft: "1px solid #aaa",
                        padding: "0px 10px",
                        width: "50%",
                      }}
                    >
                      <Row justify="start">
                        <b>ยอดใช้จริง/Practical Use</b>
                      </Row>
                      <Row justify="end">
                        <p>{numberWithCommas(transferGiftvoucher?.price, 2)}</p>
                      </Row>
                    </td>
                  </tr>
                </table>
              </div>
            )}
            {typePurchase === "normal" && (
              <div style={{ padding: "0px 20px", marginTop: "20px" }}>
                <table width="100%" style={{ fontSize: "14px" }}>
                  <tr
                    style={{
                      backgroundColor: "#fff",
                      height: "50px",
                    }}
                  >
                    <td
                      style={{
                        borderRight: "0px solid #aaa",
                        padding: "0px 10px",
                        background: "#E76464",
                        color: "#fff",
                      }}
                    >
                      ยอดเงินส่วนลดทั้งหมด/Total discount amount
                    </td>
                    <td
                      align="right"
                      style={{
                        borderLeft: "0px solid #aaa",
                        padding: "0px 10px",
                        color: "#fff",
                        background: "#E76464",
                      }}
                    >
                      <b>
                        {numberWithCommas(
                          sum[0]?.totalDiscount !== undefined &&
                            sum[0]?.totalDiscount,
                          2
                        )}
                      </b>
                    </td>
                  </tr>
                </table>
              </div>
            )}
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                      color: "#000",
                    }}
                  >
                    ยอดเงินหลังหักส่วนลดทั้งหมด/ Balance after all discounts.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      color: "#000",
                      background: "#fff",
                    }}
                  >
                    <b>
                      {numberWithCommas(
                        sum[0].balanceafter !== undefined &&
                          sum[0].balanceafter,
                        2
                      )}
                    </b>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div
          className="row space-between mt-20"
          style={{ padding: "0px 40px" }}
        >
          <div className="col-4"></div>
        </div>
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Space>
            <Button
              style={{
                background: "#5BAEA9",
                color: "white",
                height: "50px",
                borderRadius: "0.25rem",
              }}
              onClick={() => history.push(`/opd/so/buy/${id}`)}
            >
              เลือกซื้อต่อ/Continue Selection
            </Button>
            <Button
              style={{
                background: "#4D7E7F",
                color: "white",
                height: "50px",
                borderRadius: "0.25rem",
              }}
              onClick={() => OnSummary()}
            >
              ยืนยันรายการ/Confirm Item
            </Button>
          </Space>
        </Row>
      </div>
    </div>
  );
};
export default Cart;
